import moment from 'moment-timezone';
import { useEffect } from 'react';

import { useActiveElements } from 'global/ActiveElements/useActiveElements';

import { makeActiveElementsConfig, PAGE_KEY } from './activeElementsConfigFactory';
import { crewTimelineStore } from './CrewTimelineStore';
import { useFilterQueryParams } from './useFilterQueryParams';

export function useCrewTimeline() {
	const {
		isTimelineError,
		isTimelineLoading,
		isNothingFound,
		isReadyShowResult,
		errorText,
		timelineData,
		displayDays,
		selectedTimezone,
		canNavigatePrevious,
		canNavigateNext,
		setFilters,
		fetchTimeline,
		navigateToPreviousPeriod,
		navigateToNextPeriod,
		navigateToToday,
	} = crewTimelineStore;

	const active = useActiveElements();

	useFilterQueryParams();

	const timezoneValue =
		typeof selectedTimezone === 'string'
			? selectedTimezone
			: selectedTimezone?.value || moment.tz.guess();

	useEffect(() => {
		if (active.active) active.closeActiveElement();

		const modalConfig = makeActiveElementsConfig(timezoneValue);

		active.mountForPage(PAGE_KEY, modalConfig);

		return () => active.cleanupPage(PAGE_KEY);
	}, [active, timezoneValue]);

	useEffect(() => {
		fetchTimeline();
	}, [fetchTimeline]);

	return {
		isTimelineError,
		isTimelineLoading,
		isNothingFound,
		isReadyShowResult,
		errorText,
		timelineData,
		canNavigatePrevious,
		canNavigateNext,
		displayDays,
		setFilters,
		navigateToPreviousPeriod,
		navigateToNextPeriod,
		navigateToToday,
	};
}
